import { render } from "./bookkeep.vue?vue&type=template&id=3229f858"
import script from "./bookkeep.vue?vue&type=script&lang=js"
export * from "./bookkeep.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kevintam\\Documents\\hko\\mindsTest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__